import React, { useCallback } from 'react';

import KnobInput from 'components/form/KnobInput.component';
import WidgetTitle from 'components/widget/WidgetTitle.component';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import { useTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import asObject from 'utils/objects/asObject.util';
import isMissing from 'utils/predicates/any/isMissing.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './WidgetRepeatPeriod.module.scss';

// TODO: make one KnobCloudInput component to use instead both similar CategoryTimeOff and WidgetRepeatUntil
const WidgetRepeatPeriod = ({ disabled, name: nameFromProps, onChange = alwaysNoop, options, selected: selectedFromProps, tag: tagFromProps }) => {
  const { t } = useTranslation();
  const name = fromAnyToTrimmed(nameFromProps);
  const tag = fromAnyToTrimmed(tagFromProps);

  const [selected, setSelected] = useStateWhileMounted(selectedFromProps);
  const selectedId = asObject(selected).id;

  const handleClick = useCallback(
    //
    (ev) => {
      const raw = selectedId === ev.name ? null : ev.raw;

      const { value } = asObject(call(`WidgetRepeatPeriod.onChange`, onChange, { name, tag, raw }));

      setSelected(isMissing(value) ? raw : value);
    },
    [name, onChange, selectedId, setSelected, tag],
  );

  return (
    <div data-bem="WidgetRepeatPeriod" data-tag={tag} className={CN.component}>
      <div className={CN.titleContainer}>
        <WidgetTitle tag="WidgetRepeatPeriod__title">{t('scheduler.timeOff.repeatTitle')}</WidgetTitle>
      </div>

      <div data-bem="WidgetRepeatPeriod__list" data-tag={tag} className={CN.list}>
        {asArray(options).map((option) => (
          <KnobInput
            key={createNodeKey({ tag: option.description, unique: option.id })}
            disabled={disabled}
            name={option.id}
            onClick={handleClick}
            selected={selectedId === option.id}
            tag="WidgetRepeatPeriod__item"
            value={option}
          >
            {option.description}
          </KnobInput>
        ))}
      </div>
    </div>
  );
};
export default WidgetRepeatPeriod;
